// extracted by mini-css-extract-plugin
export default {"overlay":"Img_overlay__JkF19","overlayIcon":"Img_overlayIcon__2Svml"};